import React, { useState, useRef } from "react";
import Select from "react-select";
import { Button } from "react-bootstrap";
import { Loader } from "../../components";
import { useSelector } from "react-redux";
import { useForm } from "../../hooks";
import { restaurantCity, restaurantType } from "../../data";
import {
  GoogleMap,
  LoadScript,
  Marker,
  Autocomplete,
} from "@react-google-maps/api";
import { creationValidations } from "../../helpers/formValidations";
import { notify } from "../../helpers/commonFunction";

const containerStyle = {
  width: "100%",
  height: "200px",
  borderRadius: "8px",
};

const BranchCreation = () => {
  const { loader } = useSelector((state) => state.creationReducer);
  const [mapCenter, setMapCenter] = useState({ lat: 14.5995, lng: 120.9842 }); // Default Manila
  const autocompleteRef = useRef(null);

  const initialFValues = {
    restaurant_group: "",
    branch: "",
    city: "",
    username: "",
    password: "",
    address: "",
  };

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    return creationValidations(fieldValues, temp, values, setValues, setErrors);
  };

  const { errors, setErrors, values, setValues, handleInputChange } = useForm(
    initialFValues,
    true,
    validate
  );

  const handlePlaceChanged = () => {
    const place = autocompleteRef.current?.getPlace();
    if (!place || !place.geometry) return;
    const location = place.geometry.location;
    const lat = location.lat();
    const lng = location.lng();
    setValues((prev) => ({
      ...prev,
      address: place.formatted_address,
      lat,
      lng,
    }));
    setMapCenter({ lat, lng });
  };

  const handleSubmitData = () => {
    if (!validate()) return;
    const restaurantGroup = values.restaurant_group?.label?.trim();
    const branchName = values.branch?.trim();
    const cityName = values.city?.label?.trim();

    const newBranch = {
      label: branchName,
      value: branchName.toLowerCase().replace(/\s+/g, "_"),
      address: values.address,
      city: cityName,
      lat: values.lat,
      lng: values.lng,
    };

    const existingGroups =
      JSON.parse(localStorage.getItem("restaurantGroups")) || [];
    const existingGroupIndex = existingGroups.findIndex(
      (group) => group.label.toLowerCase() === restaurantGroup.toLowerCase()
    );

    if (existingGroupIndex !== -1) {
      const existingBranch = existingGroups[existingGroupIndex].branches.find(
        (b) => b.label.toLowerCase() === newBranch.label.toLowerCase()
      );
      if (existingBranch) {
        notify("This branch already exists for the selected group.", "warning");
        return;
      }
      existingGroups[existingGroupIndex].branches.push(newBranch);
    } else {
      const newGroup = {
        label: restaurantGroup,
        value: restaurantGroup.toLowerCase().replace(/\s+/g, "_"),
        branches: [{ label: "All Branches", value: "all" }, newBranch],
      };
      existingGroups.push(newGroup);
    }

    localStorage.setItem("restaurantGroups", JSON.stringify(existingGroups));
    notify("Branch saved successfully!", "success");
    setValues(initialFValues);
    setMapCenter({ lat: 14.5995, lng: 120.9842 });
  };

  return (
    <>
      {loader && <Loader />}
      <div className="tc-content-wrapper rx-agad-page tc-content-creation-wrapper h-100 p-0">
        <div className="create-rx-agad-page-title-wrapper">
          <h2>CREATE BRANCH</h2>
        </div>

        <div className="tc-calls-container tc-calls-details-container TM-Territory-main-box h-100 overflow-auto create-rx-agad-main-box">
          <div className="w-100 create-rx-agad-wrapper">
            <div className="mb-4">
              <div className="tc-card-itinerary-content">
                <div className="tc-card-itinerary-container form-group">
                  <div className="tc-card-input-container mb-3">
                    <div className="tc-card-input-label">
                      <span>Restaurant Group</span>
                      <span>:</span>
                    </div>
                    <div className="tc-card-input-box form-input-box">
                      <Select
                        id="restaurant_group"
                        name="restaurant_group"
                        value={values?.restaurant_group}
                        options={restaurantType}
                        className={`tc-custom-select-2 w-100 mb-0`}
                        classNamePrefix="select"
                        placeholder="Select..."
                        onChange={(e) => {
                          handleInputChange(e, "restaurant_group");
                          setErrors((prev) => ({
                            ...prev,
                            restaurant_group: "",
                          }));
                        }}
                      />
                      {errors?.restaurant_group && (
                        <span className="tc_error_text">
                          {errors?.restaurant_group}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="tc-card-input-container mb-3">
                    <div className="tc-card-input-label">
                      <span>Branch</span>
                      <span>:</span>
                    </div>
                    <div className="tc-card-input-box form-input-box">
                      <input
                        type="text"
                        id="branch"
                        name="branch"
                        value={values?.branch}
                        className="tc-card-static-input"
                        placeholder="Enter branch"
                        onChange={handleInputChange}
                      />
                      {errors?.branch && (
                        <span className="tc_error_text">{errors?.branch}</span>
                      )}
                    </div>
                  </div>
                  <div className="tc-card-input-container mb-3">
                    <div className="tc-card-input-label">
                      <span>City</span>
                      <span>:</span>
                    </div>
                    <div className="tc-card-input-box form-input-box">
                      <Select
                        id="city"
                        name="city"
                        value={values?.city}
                        options={restaurantCity}
                        className={`tc-custom-select-2 w-100 mb-0`}
                        classNamePrefix="select"
                        placeholder="Select..."
                        onChange={(e) => {
                          handleInputChange(e, "city");
                          setErrors((prev) => ({ ...prev, city: "" }));
                        }}
                      />
                      {errors?.city && (
                        <span className="tc_error_text">{errors?.city}</span>
                      )}
                    </div>
                  </div>
                  <div className="tc-card-input-container mb-3">
                    <div className="tc-card-input-label">
                      <span>Username</span>
                      <span>:</span>
                    </div>
                    <div className="tc-card-input-box form-input-box">
                      <input
                        type="text"
                        id="username"
                        name="username"
                        placeholder="Enter username"
                        className="tc-card-static-input"
                        value={values?.username}
                        onChange={handleInputChange}
                      />
                      {errors?.username && (
                        <span className="tc_error_text">
                          {errors?.username}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="tc-card-input-container mb-3">
                    <div className="tc-card-input-label">
                      <span>Password</span>
                      <span>:</span>
                    </div>
                    <div className="tc-card-input-box form-input-box">
                      <input
                        type="password"
                        id="password"
                        name="password"
                        placeholder="Enter password"
                        className="tc-card-static-input"
                        value={values?.password}
                        onChange={handleInputChange}
                      />
                      {errors?.password && (
                        <span className="tc_error_text">
                          {errors?.password}
                        </span>
                      )}
                    </div>
                  </div>
                  <LoadScript
                    googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAP_KEY}
                    libraries={["places"]}
                  >
                    <div className="tc-card-input-container mb-3">
                      <div className="tc-card-input-label">
                        <span>Complete Address</span>
                        <span>:</span>
                      </div>
                      <div className="tc-card-input-box form-input-box">
                        <Autocomplete
                          onLoad={(ref) => (autocompleteRef.current = ref)}
                          onPlaceChanged={handlePlaceChanged}
                        >
                          <input
                            type="text"
                            id="address"
                            name="address"
                            value={values?.address}
                            onChange={handleInputChange}
                            className="tc-card-static-input"
                            placeholder="Start typing address..."
                          />
                        </Autocomplete>
                        {errors?.address && (
                          <span className="tc_error_text">
                            {errors?.address}
                          </span>
                        )}
                      </div>
                    </div>
                    <GoogleMap
                      mapContainerStyle={containerStyle}
                      center={mapCenter}
                      zoom={15}
                    >
                      <Marker position={mapCenter} />
                    </GoogleMap>
                  </LoadScript>
                </div>
              </div>
            </div>
            <div className="btn-wrapper">
              <div className="tc-card-input-container">
                <div className="tc-card-input-label d-flex justify-content-center">
                  <Button
                    className="submit-btn"
                    type="button"
                    onClick={handleSubmitData}
                  >
                    SUBMIT
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BranchCreation;
